import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { NoticeService } from '../services/notice.service';

/** Surfaces a 403 from the API instead of failing quietly. Login uses 403 for the wrong app. */
export const forbiddenInterceptor: HttpInterceptorFn = (req, next) => {
  const notices = inject(NoticeService);
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 403 && !req.url.includes('/auth/login')) {
        const message = err.error?.error?.message ?? "You don't have permission to perform this action.";
        notices.show(message);
      }
      return throwError(() => err);
    })
  );
};
